import {
    Box,
    Button,
    Card,
    CardContent,
    Grid,
    Link,
    Stack,
    Typography,
} from '@mui/material';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { ShowBase, useShowContext } from 'react-admin';
import { Link as RouterLink } from 'react-router-dom';
import { ExpensesClaimSummary } from '@wwf/sdk';
import { LabelValueRow } from '@app/misc/LabelValueRow';

export const ExpensesClaimShow = () => (
    <ShowBase resource="expensesClaim">
        <ExpensesClaimShowContent />
    </ShowBase>
);

const ExpensesClaimShowContent = () => {
    const { record, isPending } = useShowContext<ExpensesClaimSummary>();

    if (isPending || !record) return null;

    return (
        <Grid container spacing={2} mt={1} rowGap={4}>
            <Grid item xs={12}>
                <Stack flex="1" flexDirection="column" gap={2}>
                    <InfoCard record={record} />
                </Stack>
            </Grid>
        </Grid>
    );
};

const InfoCard = ({ record }: { record: ExpensesClaimSummary }) => (
    <Box>
        <Card>
            <CardContent>
                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="flex-start"
                    gap={2}
                >
                    <Typography variant="h5">{record.name}</Typography>
                    <Button
                        component={RouterLink}
                        to={`/expenses_claim?edit=${record.id}`}
                        size="small"
                        variant="outlined"
                        startIcon={<EditOutlinedIcon />}
                    >
                        Edit
                    </Button>
                </Box>
                <LabelValueRow label="Details" value={record.details || '—'} />
                <LabelValueRow
                    label="App Scheme"
                    value={record.appScheme || '—'}
                />
                <LabelValueRow
                    label="URL"
                    value={
                        record.url ? (
                            <Link
                                href={`${record.url}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                underline="hover"
                            >
                                {record.url}
                            </Link>
                        ) : (
                            '—'
                        )
                    }
                />
                <LabelValueRow
                    label="Document URL"
                    value={
                        record.docUrl ? (
                            <Link
                                href={`${record.docUrl}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                underline="hover"
                            >
                                {record.docUrl}
                            </Link>
                        ) : (
                            '—'
                        )
                    }
                />
            </CardContent>
        </Card>
    </Box>
);
